import React from 'react';

import Divider from '@hero/ui-kit/components/Divider';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import P from '@hero/ui-kit/typography/P';

import { ListFilterOption } from '../../../components/ListFilter';
import * as Style from '../style.module.scss';

type Props = {
    options: ListFilterOption[];
    selected: string[];
    onToggle: (value: string) => void;
};

// Monthly Care's own month list, so the shared filter rows stay untouched.
const MonthList: React.FC<Props> = ({ options, selected, onToggle }) => (
    <div className={Style.monthList}>
        {options.map((option) => (
            <React.Fragment key={option.value}>
                <ClickableOpacity
                    fullWidth
                    alt={`Show ${option.label}`}
                    aria-pressed={selected.includes(option.value)}
                    className={`${Style.monthRow} ${
                        selected.includes(option.value) ? Style.monthRowActive : ''
                    }`}
                    onClick={() => onToggle(option.value)}
                >
                    <P noDefaultMargin>{option.label}</P>
                </ClickableOpacity>
                {option.dividerAfter ? (
                    <div className={Style.monthDivider}>
                        <Divider noDefaultMargin />
                    </div>
                ) : null}
            </React.Fragment>
        ))}
    </div>
);

export default MonthList;
